var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.9997 50C99.9997 61.3169 96.2203 71.8107 89.8873 80.2469C86.4144 84.7737 82.2264 88.786 77.4256 91.8724C69.6626 97.0165 60.3674 100 50.3572 100C22.8802 100 0.612549 77.572 0.612549 50C0.612549 22.3251 22.8802 0 50.255 0C60.2653 0 69.5604 2.98354 77.3235 8.02469C82.1243 11.1111 86.3122 15.1235 89.7852 19.6502C96.2203 28.1893 99.9997 38.5802 99.9997 50Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73647 17.5927C2.65577 17.5927 3.47293 16.8725 3.47293 15.8437C3.47293 14.9178 2.75792 14.0947 1.73647 14.0947C0.81716 14.0947 0 14.8149 0 15.8437C0 16.8725 0.715015 17.5927 1.73647 17.5927Z",
    fill: "url(#paint0_linear_2809_74670)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83949 95.6786C2.7588 95.6786 3.57596 94.9584 3.57596 93.9296C3.57596 92.9008 2.86094 92.1807 1.83949 92.1807C0.920188 92.1807 0.103027 92.9008 0.103027 93.9296C0.103027 94.9584 0.920188 95.6786 1.83949 95.6786Z",
    fill: "url(#paint1_linear_2809_74670)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0203 14.8088C95.9396 14.8088 96.6546 14.0886 96.6546 13.1627C96.6546 12.2368 95.9396 11.5166 95.0203 11.5166C94.101 11.5166 93.386 12.2368 93.386 13.1627C93.386 14.0886 94.101 14.8088 95.0203 14.8088Z",
    fill: "url(#paint2_linear_2809_74670)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2809_74670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0133 24.0294C43.393 24.323 41.9198 24.7631 40.4468 25.3502C31.6088 28.8728 25.4218 36.7986 23.9488 45.8986C23.3596 49.1276 23.5071 52.3566 24.0963 55.7323C27.0423 70.1162 41.3305 79.5098 55.766 76.4276C70.2015 73.3453 79.6289 59.2551 76.5356 44.8712C75.5045 39.7341 73.0004 35.0375 69.1705 31.3681C63.1312 24.9101 53.8514 22.1214 45.0133 24.0294Z",
    fill: "url(#paint3_linear_2809_74670)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9195 77.9717C60.4229 77.5184 68.8529 72.0386 73.2083 63.914L71.7444 60.9262L63.2148 49.1419L62.001 49.5001L55.4991 55.9999L54.001 52.5001L47.001 52.5001L42.001 51.0001L40.5012 60L50.9195 77.9717Z",
    fill: "url(#paint4_linear_2809_74670)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1975 51.1241C63.7867 50.6837 63.934 49.8031 63.4921 49.216C63.4921 49.0692 63.3448 49.0692 63.1975 48.9225L56.569 43.6386C55.9798 43.1983 55.096 43.3451 54.6541 43.9322C54.5068 44.2257 54.3595 44.5192 54.3595 44.8128V47.308H50.3823C50.0877 47.308 49.9404 47.4547 49.9404 47.7483V48.6289V52.2983C49.9404 52.5918 50.0877 52.7386 50.3823 52.7386H54.3595V55.2337C54.3595 55.9676 54.9487 56.5547 55.6852 56.5547C55.9798 56.5547 56.2744 56.4079 56.569 56.2611L63.1975 51.1241Z",
    fill: "url(#paint5_linear_2809_74670)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1732 47.6061V52.3028C48.1732 52.4496 48.0259 52.7432 47.7313 52.7432H47.1421C46.9948 52.7432 46.7002 52.5964 46.7002 52.3028V47.6061C46.7002 47.4593 46.8475 47.1658 47.1421 47.1658H47.7313C48.0259 47.1658 48.1732 47.4593 48.1732 47.6061Z",
    fill: "url(#paint6_linear_2809_74670)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1817 58.9045C40.1817 60.8125 41.6547 62.2803 43.4223 62.2803H48.7251C49.609 62.2803 50.3455 61.5464 50.3455 60.6658C50.3455 59.7851 49.609 59.198 48.7251 59.198H43.275V40.7045H48.7251C49.609 40.7045 50.1982 39.9707 50.1982 39.2368C50.1982 38.3561 49.4617 37.6223 48.7251 37.6223H43.4223C41.6547 37.6223 40.1817 39.09 40.1817 40.9981V58.9045Z",
    fill: "url(#paint7_linear_2809_74670)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2809_74670",
    x: 15.5737,
    y: 20.4395,
    width: 69.55,
    height: 69.5742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2809_74670"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2809_74670",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2809_74670",
    x1: 0,
    y1: 15.924,
    x2: 3.30194,
    y2: 15.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2809_74670",
    x1: 0.173916,
    y1: 93.9895,
    x2: 3.47586,
    y2: 93.9895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2809_74670",
    x1: 93.4258,
    y1: 13.1799,
    x2: 96.5269,
    y2: 13.1799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2809_74670",
    x1: 50.466,
    y1: 76.9197,
    x2: 50.466,
    y2: 23.4466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2809_74670",
    x1: 50.2539,
    y1: 46.9337,
    x2: 63.7171,
    y2: 74.6632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#657EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2809_74670",
    x1: 68.9896,
    y1: 36.9171,
    x2: 50.9851,
    y2: 54.9863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "#C2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2809_74670",
    x1: 52.5351,
    y1: 44.953,
    x2: 45.5945,
    y2: 51.9185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "#C2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2809_74670",
    x1: 37.2545,
    y1: 41.5723,
    x2: 55.907,
    y2: 60.2917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "#C2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.db01c5ecf5733869d36979284574bf0c.svg";
export { ForwardRef as ReactComponent };